export default [
    {
        number: "01",
        name: 'Avestruz',
        image: '/assets/bichos/01.png'
    },
    {
        number: "02",
        name: 'Águia',
        image: '/assets/bichos/02.png'
    },
    {
        number: "03",
        name: 'Burro',
        image: '/assets/bichos/03.png'
    },
    {
        number: "04",
        name: 'Borboleta',
        image: '/assets/bichos/04.png'
    },
    {
        number: "05",
        name: 'Cachorro',
        image: '/assets/bichos/05.png'
    },
    {
        number: "06",
        name: 'Cabra',
        image: '/assets/bichos/06.png'
    },
    {
        number: "07",
        name: 'Carneiro',
        image: '/assets/bichos/07.png'
    },
    {
        number: "08",
        name: 'Camelo',
        image: '/assets/bichos/08.png'
    },
    {
        number: "09",
        name: 'Cobra',
        image: '/assets/bichos/09.png'
    },
    {
        number: "10",
        name: 'Coelho',
        image: '/assets/bichos/10.png'
    },
    {
        number: "11",
        name: 'Cavalo',
        image: '/assets/bichos/11.png'
    },
    {
        number: "12",
        name: 'Elefante',
        image: '/assets/bichos/12.png'
    },
    {
        number: "13",
        name: 'Galo',
        image: '/assets/bichos/13.png'
    },
    {
        number: "14",
        name: 'Gato',
        image: '/assets/bichos/14.png'
    },
    {
        number: "15",
        name: 'Jacaré',
        image: '/assets/bichos/15.png'
    },
    {
        number: "16",
        name: 'Leão',
        image: '/assets/bichos/16.png'
    },
    {
        number: "17",
        name: 'Macaco',
        image: '/assets/bichos/17.png'
    },
    {
        number: "18",
        name: 'Porco',
        image: '/assets/bichos/18.png'
    },
    {
        number: "19",
        name: 'Pavão',
        image: '/assets/bichos/19.png'
    },
    {
        number: "20",
        name: 'Peru',
        image: '/assets/bichos/20.png'
    },
    {
        number: "21",
        name: 'Touro',
        image: '/assets/bichos/21.png'
    },
    {
        number: "22",
        name: 'Tigre',
        image: '/assets/bichos/22.png'
    },
    {
        number: "23",
        name: 'Urso',
        image: '/assets/bichos/23.png'
    },
    {
        number: "24",
        name: 'Veado',
        image: '/assets/bichos/24.png'
    },
    {
        number: "25",
        name: 'Vaca',
        image: '/assets/bichos/25.png'
    },
]


// WEBPACK FOOTER //
// ./src/utils/numberBichoData.js